import { gql } from 'apollo-angular';

export const mutationUpdate = gql`
mutation update ($params: String ) {
    Update(params: $params )
}
`;


export const mutationRespond = gql`
mutation postResponse ($params: String ) { 
    PostResponse(params: $params )
}
`;

export const mutationRespondSale = gql`
mutation postResponse ($ambassadorID: String, $params: String ) { 
    PostResponse(ambassadorID: $ambassadorID, params: $params )
}
`;
